// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReturnedCheckDetailsAllOfProcessingDecision } from './IReturnedCheckDetailsAllOfProcessingDecision';
import {
    IReturnedCheckDetailsAllOfProcessingDecisionFromJSON,
    IReturnedCheckDetailsAllOfProcessingDecisionFromJSONTyped,
    IReturnedCheckDetailsAllOfProcessingDecisionToJSON,
    IReturnedCheckDetailsAllOfProcessingDecisionToJSONTyped,
} from './IReturnedCheckDetailsAllOfProcessingDecision';

/**
 * 
 * @export
 * @interface IReturnedCheckDetails
 */
export interface IReturnedCheckDetails {
    /**
     * 
     * @type {string}
     * @memberof IReturnedCheckDetails
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof IReturnedCheckDetails
     */
    check_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReturnedCheckDetails
     */
    check_type?: IReturnedCheckDetailsCheckTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IReturnedCheckDetails
     */
    amount?: number;
    /**
     * 
     * @type {IReturnedCheckDetailsAllOfProcessingDecision}
     * @memberof IReturnedCheckDetails
     */
    processing_decision?: IReturnedCheckDetailsAllOfProcessingDecision;
    /**
     * 
     * @type {string}
     * @memberof IReturnedCheckDetails
     */
    pay_to?: string;
}

/**
* @export
* @enum {string}
*/
export enum IReturnedCheckDetailsCheckTypeEnum {
    LOCKBOX = 'LOCKBOX',
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER'
}


/**
 * Check if a given object implements the IReturnedCheckDetails interface.
 */
export function instanceOfIReturnedCheckDetails(value: object): value is IReturnedCheckDetails {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function IReturnedCheckDetailsFromJSON(json: any): IReturnedCheckDetails {
    return IReturnedCheckDetailsFromJSONTyped(json, false);
}

export function IReturnedCheckDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReturnedCheckDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'check_id': json['check_id'] == null ? undefined : json['check_id'],
        'check_type': json['check_type'] == null ? undefined : json['check_type'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'processing_decision': json['processing_decision'] == null ? undefined : IReturnedCheckDetailsAllOfProcessingDecisionFromJSON(json['processing_decision']),
        'pay_to': json['pay_to'] == null ? undefined : json['pay_to'],
    };
}

export function IReturnedCheckDetailsToJSON(json: any): IReturnedCheckDetails {
    return IReturnedCheckDetailsToJSONTyped(json, false);
}

export function IReturnedCheckDetailsToJSONTyped(value?: IReturnedCheckDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'check_id': value['check_id'],
        'check_type': value['check_type'],
        'amount': value['amount'],
        'processing_decision': IReturnedCheckDetailsAllOfProcessingDecisionToJSON(value['processing_decision']),
        'pay_to': value['pay_to'],
    };
}

